import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface CompanyInfo {
  address: string;
  hours: string[];
  emails: string[];
  phones: string[];
}

@Component({
  selector: 'company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.css']
})

export class CompanyInfoComponent implements OnInit {
  companyInfo?: CompanyInfo;

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.http.get<CompanyInfo>('assets/company-info.json').subscribe(data => {
      this.companyInfo = data;
    });
  }
}
